import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import DateReference from './date_reference';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import ManagedInput from 'components/form/managed_input';
import Options from 'components/form/managed_input/options';
import { isDealPlaybook } from 'bundles/apex/playbooks/config/helpers';

export default function DueDates({ playbook, task, setDueDate }) {
  const operatorOptions = ['after', 'before'];
  const unitsOptions = [
    { label: 'Days', value: 'day' },
    { label: 'Weeks', value: 'week' },
    { label: 'Months', value: 'month' }
  ];

  const dateTypesSet = [];
  let targetLabel = 'Stage';

  if (isDealPlaybook(playbook)) {
    dateTypesSet.push({
      value: 'relative',
      label: 'Relative Critical Date',
      getTaskDateValues: () => ({ modifier, units, operator, dateReference }),
      isTask: () => (task && task.dateReference)
    });
    targetLabel = 'Status';
  }
  dateTypesSet.push(
    {
      value: 'stageUpdate',
      label: `Days After ${targetLabel} Update`,
      getTaskDateValues: () => ({ modifier, dateReference: null, operator: 'after', units: 'day' }),
      isTask: () => (task && task.modifier != null && task.modifier >= 0 && !task.dateReference)
    },
    {
      value: 'none',
      label: 'None',
      getTaskDateValues: () => ({ modifier: null, dateReference: null }),
      isTask: () => (!task || (!task.modifier && !task.dateReference))
    }
  );

  const [dateType, setDateType] = useState(dateTypesSet.find(type => type.isTask())?.value || 'none');
  const [modifier, setModifier] = useState(task?.modifier ? task.modifier : 0);
  const [units, setUnits] = useState(task?.units || 'day');
  const [operator, setOperator] = useState(task?.operator || 'before');
  const [dateReference, setDateReference] = useState();

  const dateTypeOptions = dateTypesSet.map(type => (
    { value: type.value, label: type.label }
  ));

  useEffect(() => {
    setDueDate(dateTypesSet.find(element => element.value === dateType).getTaskDateValues());
  }, [dateType, modifier, units, operator, dateReference]);

  return <>
    <ManagedFormGroup
      label="Due Dates"
      name="dateType"
      options={dateTypeOptions}
      type="radioGroup"
      value={dateType}
      onValueChange={setDateType}
    />

    <div className="d-flex align-items-center flex-wrap gap-1 mt-3">
      {dateType !== 'none' &&
        <ManagedInput
          className="due-dates-input form-control"
          min="0"
          name="modifier"
          type="number"
          value={modifier}
          onValueChange={setModifier}
        />
      }

      {dateType === 'stageUpdate' &&
        <span>Days After Stage Update</span>
      }

      {dateType === 'relative' && <>
        <ManagedInput
          className="due-dates-dropdown"
          name="units"
          type="select"
          value={units}
          onValueChange={setUnits}
        >
          <Options options={unitsOptions} />
        </ManagedInput>

        <ManagedInput
          className="due-dates-dropdown"
          name="operator"
          type="select"
          value={operator}
          onValueChange={setOperator}
        >
          {operatorOptions.map(operator => (
            <option key={operator} value={operator}>
              {operator.capitalize()}
            </option>
          ))}
        </ManagedInput>

        <div style={{ flexBasis: '100%' }}>
          <DateReference
            dateReference={dateReference}
            playbook={playbook}
            setDateReference={setDateReference}
            task={task}
          />
        </div>
      </>}
    </div>
  </>;
}

DueDates.propTypes = {
  playbook: PropTypes.object.isRequired,
  setDueDate: PropTypes.func.isRequired,
  task: PropTypes.object
};
